export const MANUFACTURER_REQUEST_STATUSES = {
  PENDING: 1,
  APPROVED: 2,
  DECLINED: 3,
};
